import { useEffect, useState } from "react";
import { Button, message, Row, Col, Form, Input, Switch } from "antd";
import { getData, postData, putData } from "../../../../apiServices/common";
import {
  AU_FORMULA_ADD_ENDPOINT,
  AU_FORMULA_EDIT_GET_ENDPOINT,
  AU_FORMULA_EDIT_PUT_ENDPOINT,
} from "../../../../apiServices/API_ENDPOINTS";

const AuFormulaForm = (props) => {
  const { isEdit, isView, onCloseModal, refetch, selectedItem } = props;

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (isEdit || isView) {
      if (selectedItem?.id) {
        const fetchEditData = async () => {
          setLoading(true);
          const response = await getData(`${AU_FORMULA_EDIT_GET_ENDPOINT}/${selectedItem.id}/edit`);
          setLoading(false);
          if (response?.data?.code === 200 && response?.data?.data) {
            const data = response.data.data;
            form.setFieldsValue({
              id: data?.id,
              name: data?.name,
              description: data?.description ?? "",
              status: data?.status ? true : false,
            });
          } else if (selectedItem) {
            form.setFieldsValue({
              id: selectedItem?.id,
              name: selectedItem?.name,
              description: selectedItem?.description ?? "",
              status: selectedItem?.status ? true : false,
            });
          }
        };
        fetchEditData();
      } else if (selectedItem) {
        form.setFieldsValue({
          id: selectedItem?.id,
          name: selectedItem?.name,
          description: selectedItem?.description ?? "",
          status: selectedItem?.status ? true : false,
        });
      }
    }
  }, [selectedItem, isEdit, isView, form]);

  const createNew = async (formValues) => {
    setLoading(true);
    const bodyData = {
      name: formValues?.name,
      description: formValues?.description ?? "",
      status: formValues?.status ? 1 : 0,
    };

    const response = await postData(AU_FORMULA_ADD_ENDPOINT, bodyData);

    if (response?.data?.code === 200 || response?.code === 200) {
      setLoading(false);
      message.success("AU Formula created successfully");
      refetch();
      form.resetFields();
      onCloseModal();
    } else {
      setLoading(false);
      message.error(response?.data?.message || "Something went wrong");
    }
  };

  const editSelected = async (formValues) => {
    setLoading(true);
    const bodyData = {
      name: formValues?.name,
      description: formValues?.description ?? "",
      status: formValues?.status ? 1 : 0,
    };

    const response = await putData(`${AU_FORMULA_EDIT_PUT_ENDPOINT}/${formValues?.id}`, bodyData);

    if (response?.data?.code === 200 || response?.code === 200) {
      setLoading(false);
      message.success("AU Formula updated successfully");
      refetch();
      form.resetFields();
      onCloseModal();
    } else {
      setLoading(false);
      message.error(response?.data?.message || "Something went wrong");
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={isEdit ? editSelected : createNew} disabled={isView}>
      <Form.Item name="id" hidden />
      <Form.Item name="name" label="Name" rules={[{ required: true, message: "Name is required" }]}>
        <Input size="small" placeholder="Name" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea size="small" rows={3} placeholder="Description" />
      </Form.Item>
      <Form.Item
        name="status"
        label="Status"
        valuePropName="checked"
        initialValue={true}
        rules={[{ required: true, message: "Status is required" }]}
      >
        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
      </Form.Item>
      {!isView && (
        <Row gutter={6}>
          <Col span={12}>
            <Button type="default" danger style={{ width: "100%" }} onClick={onCloseModal} size="small">
              Discard
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }} loading={loading} size="small">
              Save
            </Button>
          </Col>
        </Row>
      )}
      {isView && (
        <Button type="primary" onClick={onCloseModal} size="small" block>
          Close
        </Button>
      )}
    </Form>
  );
};

export default AuFormulaForm;
